export const TOGGLE_FAQ_MODAL = "TOGGLE_FAQ_MODAL";
export const TOGGLE_TERMS_MODAL = "TOGGLE_TERMS_MODAL";
export const TOGGLE_PRIVACY_MODAL = "TOGGLE_PRIVACY_MODAL";
export const TOGGLE_CONTACT_MODAL = "TOGGLE_CONTACT_MODAL";
export const TOGGLE_TAKE_PART_MODAL = "TOGGLE_TAKE_PART_MODAL";
export const TOGGLE_LANGUAGE_MODAL = "TOGGLE_LANGUAGE_MODAL";
export const SELECT_LANGUAGE = "SELECT_LANGUAGE"
